export default "__VITE_PUBLIC_ASSET__429aab57__"